export const EmptyShoppingCart: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
  >
    <path
      d="M21.8334 58.6654C23.3062 58.6654 24.5001 57.4715 24.5001 55.9987C24.5001 54.5259 23.3062 53.332 21.8334 53.332C20.3607 53.332 19.1667 54.5259 19.1667 55.9987C19.1667 57.4715 20.3607 58.6654 21.8334 58.6654Z"
      stroke="black"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.1667 58.6654C52.6394 58.6654 53.8333 57.4715 53.8333 55.9987C53.8333 54.5259 52.6394 53.332 51.1667 53.332C49.6939 53.332 48.5 54.5259 48.5 55.9987C48.5 57.4715 49.6939 58.6654 51.1667 58.6654Z"
      stroke="black"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.9668 5.46875H11.3001L18.3935 38.5888C18.6537 39.8017 19.3286 40.886 20.302 41.655C21.2755 42.4241 22.4865 42.8297 23.7268 42.8021H49.8068C51.0206 42.8001 52.1974 42.3842 53.1429 41.623M14.1535 18.8021H32.5"
      stroke="black"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.5 18.8008H59.4068L56.5 32.0013"
      stroke="black"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1667 5.33203L60.5001 46.6654"
      stroke="black"
      strokeWidth="5.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
